/**
 * src/app/marketplace/components/MarketplaceResolving.js
 * ---------------------------------------------------------------------------
 * Shown while the session is still being confirmed with the server.
 * ---------------------------------------------------------------------------
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import '../marketplace.css';

export default function MarketplaceResolving({ provider, message }) {
	return (
		<>
			<Helmet>
				<title>{provider.label} | Uplyft Capital</title>
			</Helmet>
			<main className="mp-page" role="main">
				<div className="container">
					<div className="mp-card">
      					<div className='spinner'><div className='loader'>submitting...</div></div>

						<p className="mp-resolving" role="status" aria-live="polite">
							{message}
						</p>
					</div>
				</div>
			</main>
		</>
	);
}
